// src/components/ConfirmationPopup.jsx
import { motion, AnimatePresence } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

export function ConfirmationPopup({ isOpen, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="relative max-w-md w-full bg-[#e5e5e0] border border-black/10 rounded-2xl shadow-2xl p-8"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-black/10 flex items-center justify-center">
                <FaCheckCircle className="text-black text-3xl" />
              </div>

              <h3 className="text-2xl font-amiamie font-bold text-black mb-2">
                Message Sent Successfully
              </h3>

              <p className="text-black/70 text-sm leading-relaxed mb-6">
                Thank you for reaching out. I've received your message and will
                get back to you within{" "}
                <strong className="text-black">24 hours</strong> to discuss next
                steps.
              </p>

              <div className="w-12 h-0.5 bg-black/20 mx-auto mb-6" />

              <p className="text-black/40 text-xs">You'll hear from me soon.</p>

              <button
                onClick={onClose}
                className="mt-6 px-6 py-2 bg-black text-white rounded-lg hover:bg-black/80 transition-colors text-sm font-medium"
              >
                Got it
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
